import { useInfiniteQuery } from "@tanstack/react-query";
import { getRecentSearches, RecentSearchesResponse } from "common/apis";
import { useAuth } from "../auth/useAuth";

interface UseSavedSearchesOptions {
  /** Whether the query should be enabled. Defaults to true (will still check user login) */
  enabled?: boolean;
}

export const useSavedSearches = (options?: UseSavedSearchesOptions) => {
  // 1. Get the reactive user object
  const { user } = useAuth();

  return useInfiniteQuery<RecentSearchesResponse, Error>({
    // 2. Include user.id in the key.
    // This ensures that if user A logs out and B logs in, the cache is separated/reset.
    queryKey: ["savedSearches", user?.id],
    
    queryFn: async ({ pageParam }) => {
      // 3. Use the token from the auth state, not Storage directly
      const token = user?.accessToken || "";
      const page = pageParam as number;
      return getRecentSearches(token, page, 5, "saved");
    },
    
    getNextPageParam: (lastPage) => {
      if (!lastPage?.pagination) {
        return undefined;
      }
      const { current_page, last_page } = lastPage.pagination;
      if (current_page < last_page) {
        return current_page + 1;
      }
      return undefined;
    },
    
    initialPageParam: 1,
    
    // 4. Only run this query if the user is logged in AND enabled option is true
    enabled: !!user && (options?.enabled !== false),
    
    retry: 1,
    retryDelay: 1000,
  });
};